"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isGenesisDomain = _interopRequireDefault(require("./isGenesisDomain"));
var _getAppConfig = _interopRequireDefault(require("../constants/getAppConfig"));
const shouldLogFromConsoleWrap = message => {
  if ((0, _isGenesisDomain.default)()) return true;
  const config = (0, _getAppConfig.default)();
  const {
    consoleCaptureRegExp
  } = config.logging;
  const tester = new RegExp(consoleCaptureRegExp);
  return tester.test(message);
};
var _default = exports.default = shouldLogFromConsoleWrap;